import React from "react";

import classNames from "../utils/classnames";

import IconActivity from "@tabler/icons-react/dist/esm/icons/IconActivity.mjs";
import IconAlertTriangle from "@tabler/icons-react/dist/esm/icons/IconAlertTriangle.mjs";
import IconAlertTriangleFilled from "@tabler/icons-react/dist/esm/icons/IconAlertTriangleFilled.mjs";
import IconAlignJustified from "@tabler/icons-react/dist/esm/icons/IconAlignJustified.mjs";
import IconArchive from "@tabler/icons-react/dist/esm/icons/IconArchive.mjs";
import IconArrowBackUp from "@tabler/icons-react/dist/esm/icons/IconArrowBackUp.mjs";
import IconArrowForwardUp from "@tabler/icons-react/dist/esm/icons/IconArrowForwardUp.mjs";
import IconArrowLeft from "@tabler/icons-react/dist/esm/icons/IconArrowLeft.mjs";
import IconArrowRight from "@tabler/icons-react/dist/esm/icons/IconArrowRight.mjs";
import IconArrowsMaximize from "@tabler/icons-react/dist/esm/icons/IconArrowsMaximize.mjs";
import IconArrowsMinimize from "@tabler/icons-react/dist/esm/icons/IconArrowsMinimize.mjs";
import IconBell from "@tabler/icons-react/dist/esm/icons/IconBell.mjs";
import IconBellOff from "@tabler/icons-react/dist/esm/icons/IconBellOff.mjs";
import IconBinaryTree2 from "@tabler/icons-react/dist/esm/icons/IconBinaryTree2.mjs";
import IconBlockquote from "@tabler/icons-react/dist/esm/icons/IconBlockquote.mjs";
import IconBold from "@tabler/icons-react/dist/esm/icons/IconBold.mjs";
import IconBrandDiscordFilled from "@tabler/icons-react/dist/esm/icons/IconBrandDiscordFilled.mjs";
import IconBrandGithub from "@tabler/icons-react/dist/esm/icons/IconBrandGithub.mjs";
import IconBrandSlack from "@tabler/icons-react/dist/esm/icons/IconBrandSlack.mjs";
import IconBriefcase from "@tabler/icons-react/dist/esm/icons/IconBriefcase.mjs";
import IconBuilding from "@tabler/icons-react/dist/esm/icons/IconBuilding.mjs";
import IconBuildingCommunity from "@tabler/icons-react/dist/esm/icons/IconBuildingCommunity.mjs";
import IconBuildingEstate from "@tabler/icons-react/dist/esm/icons/IconBuildingEstate.mjs";
import IconBulb from "@tabler/icons-react/dist/esm/icons/IconBulb.mjs";
import IconCalendar from "@tabler/icons-react/dist/esm/icons/IconCalendar.mjs";
import IconCalendarEvent from "@tabler/icons-react/dist/esm/icons/IconCalendarEvent.mjs";
import IconCalendarMinus from "@tabler/icons-react/dist/esm/icons/IconCalendarMinus.mjs";
import IconCalendarPlus from "@tabler/icons-react/dist/esm/icons/IconCalendarPlus.mjs";
import IconChartColumn from "@tabler/icons-react/dist/esm/icons/IconChartColumn.mjs";
import IconCheck from "@tabler/icons-react/dist/esm/icons/IconCheck.mjs";
import IconChecklist from "@tabler/icons-react/dist/esm/icons/IconChecklist.mjs";
import IconChecks from "@tabler/icons-react/dist/esm/icons/IconChecks.mjs";
import IconChevronDown from "@tabler/icons-react/dist/esm/icons/IconChevronDown.mjs";
import IconChevronLeft from "@tabler/icons-react/dist/esm/icons/IconChevronLeft.mjs";
import IconChevronRight from "@tabler/icons-react/dist/esm/icons/IconChevronRight.mjs";
import IconChevronUp from "@tabler/icons-react/dist/esm/icons/IconChevronUp.mjs";
import IconCircle from "@tabler/icons-react/dist/esm/icons/IconCircle.mjs";
import IconCircleArrowRight from "@tabler/icons-react/dist/esm/icons/IconCircleArrowRight.mjs";
import IconCircleCheck from "@tabler/icons-react/dist/esm/icons/IconCircleCheck.mjs";
import IconCircleCheckFilled from "@tabler/icons-react/dist/esm/icons/IconCircleCheckFilled.mjs";
import IconCircleDashed from "@tabler/icons-react/dist/esm/icons/IconCircleDashed.mjs";
import IconCircleDot from "@tabler/icons-react/dist/esm/icons/IconCircleDot.mjs";
import IconCircleFilled from "@tabler/icons-react/dist/esm/icons/IconCircleFilled.mjs";
import IconCircleKey from "@tabler/icons-react/dist/esm/icons/IconCircleKey.mjs";
import IconCircleX from "@tabler/icons-react/dist/esm/icons/IconCircleX.mjs";
import IconCircleXFilled from "@tabler/icons-react/dist/esm/icons/IconCircleXFilled.mjs";
import IconClipboardCheck from "@tabler/icons-react/dist/esm/icons/IconClipboardCheck.mjs";
import IconClipboardText from "@tabler/icons-react/dist/esm/icons/IconClipboardText.mjs";
import IconClock from "@tabler/icons-react/dist/esm/icons/IconClock.mjs";
import IconClockPlay from "@tabler/icons-react/dist/esm/icons/IconClockPlay.mjs";
import IconCoffee from "@tabler/icons-react/dist/esm/icons/IconCoffee.mjs";
import IconCopy from "@tabler/icons-react/dist/esm/icons/IconCopy.mjs";
import IconDeviceLaptop from "@tabler/icons-react/dist/esm/icons/IconDeviceLaptop.mjs";
import IconDoorExit from "@tabler/icons-react/dist/esm/icons/IconDoorExit.mjs";
import IconDots from "@tabler/icons-react/dist/esm/icons/IconDots.mjs";
import IconDotsVertical from "@tabler/icons-react/dist/esm/icons/IconDotsVertical.mjs";
import IconDownload from "@tabler/icons-react/dist/esm/icons/IconDownload.mjs";
import IconEdit from "@tabler/icons-react/dist/esm/icons/IconEdit.mjs";
import IconExchange from "@tabler/icons-react/dist/esm/icons/IconExchange.mjs";
import IconExclamationCircleFilled from "@tabler/icons-react/dist/esm/icons/IconExclamationCircleFilled.mjs";
import IconExternalLink from "@tabler/icons-react/dist/esm/icons/IconExternalLink.mjs";
import IconEye from "@tabler/icons-react/dist/esm/icons/IconEye.mjs";
import IconFile from "@tabler/icons-react/dist/esm/icons/IconFile.mjs";
import IconFileExport from "@tabler/icons-react/dist/esm/icons/IconFileExport.mjs";
import IconFileFilled from "@tabler/icons-react/dist/esm/icons/IconFileFilled.mjs";
import IconFileText from "@tabler/icons-react/dist/esm/icons/IconFileText.mjs";
import IconFileZip from "@tabler/icons-react/dist/esm/icons/IconFileZip.mjs";
import IconFilter from "@tabler/icons-react/dist/esm/icons/IconFilter.mjs";
import IconFlag from "@tabler/icons-react/dist/esm/icons/IconFlag.mjs";
import IconFlag3Filled from "@tabler/icons-react/dist/esm/icons/IconFlag3Filled.mjs";
import IconFlagFilled from "@tabler/icons-react/dist/esm/icons/IconFlagFilled.mjs";
import IconFlagX from "@tabler/icons-react/dist/esm/icons/IconFlagX.mjs";
import IconFlare from "@tabler/icons-react/dist/esm/icons/IconFlare.mjs";
import IconFolderFilled from "@tabler/icons-react/dist/esm/icons/IconFolderFilled.mjs";
import IconGripVertical from "@tabler/icons-react/dist/esm/icons/IconGripVertical.mjs";
import IconGrowth from "@tabler/icons-react/dist/esm/icons/IconGrowth.mjs";
import IconH1 from "@tabler/icons-react/dist/esm/icons/IconH1.mjs";
import IconH2 from "@tabler/icons-react/dist/esm/icons/IconH2.mjs";
import IconH3 from "@tabler/icons-react/dist/esm/icons/IconH3.mjs";
import IconH4 from "@tabler/icons-react/dist/esm/icons/IconH4.mjs";
import IconHash from "@tabler/icons-react/dist/esm/icons/IconHash.mjs";
import IconHeart from "@tabler/icons-react/dist/esm/icons/IconHeart.mjs";
import IconHexagons from "@tabler/icons-react/dist/esm/icons/IconHexagons.mjs";
import IconHistory from "@tabler/icons-react/dist/esm/icons/IconHistory.mjs";
import IconHome from "@tabler/icons-react/dist/esm/icons/IconHome.mjs";
import IconHome2 from "@tabler/icons-react/dist/esm/icons/IconHome2.mjs";
import IconId from "@tabler/icons-react/dist/esm/icons/IconId.mjs";
import IconInfoCircle from "@tabler/icons-react/dist/esm/icons/IconInfoCircle.mjs";
import IconInfoCircleFilled from "@tabler/icons-react/dist/esm/icons/IconInfoCircleFilled.mjs";
import IconInfinity from "@tabler/icons-react/dist/esm/icons/IconInfinity.mjs";
import IconItalic from "@tabler/icons-react/dist/esm/icons/IconItalic.mjs";
import IconKeyboard from "@tabler/icons-react/dist/esm/icons/IconKeyboard.mjs";
import IconLayoutGrid from "@tabler/icons-react/dist/esm/icons/IconLayoutGrid.mjs";
import IconLetterCase from "@tabler/icons-react/dist/esm/icons/IconLetterCase.mjs";
import IconLifebuoy from "@tabler/icons-react/dist/esm/icons/IconLifebuoy.mjs";
import IconLink from "@tabler/icons-react/dist/esm/icons/IconLink.mjs";
import IconList from "@tabler/icons-react/dist/esm/icons/IconList.mjs";
import IconListCheck from "@tabler/icons-react/dist/esm/icons/IconListCheck.mjs";
import IconListNumbers from "@tabler/icons-react/dist/esm/icons/IconListNumbers.mjs";
import IconLock from "@tabler/icons-react/dist/esm/icons/IconLock.mjs";
import IconLockFilled from "@tabler/icons-react/dist/esm/icons/IconLockFilled.mjs";
import IconLockPassword from "@tabler/icons-react/dist/esm/icons/IconLockPassword.mjs";
import IconLogs from "@tabler/icons-react/dist/esm/icons/IconLogs.mjs";
import IconMail from "@tabler/icons-react/dist/esm/icons/IconMail.mjs";
import IconMailFast from "@tabler/icons-react/dist/esm/icons/IconMailFast.mjs";
import IconMap2 from "@tabler/icons-react/dist/esm/icons/IconMap2.mjs";
import IconMenu2 from "@tabler/icons-react/dist/esm/icons/IconMenu2.mjs";
import IconMessage from "@tabler/icons-react/dist/esm/icons/IconMessage.mjs";
import IconMessagePlus from "@tabler/icons-react/dist/esm/icons/IconMessagePlus.mjs";
import IconMessageCircle from "@tabler/icons-react/dist/esm/icons/IconMessageCircle.mjs";
import IconMessages from "@tabler/icons-react/dist/esm/icons/IconMessages.mjs";
import IconMinus from "@tabler/icons-react/dist/esm/icons/IconMinus.mjs";
import IconMoodPlus from "@tabler/icons-react/dist/esm/icons/IconMoodPlus.mjs";
import IconMoodSad from "@tabler/icons-react/dist/esm/icons/IconMoodSad.mjs";
import IconMoon from "@tabler/icons-react/dist/esm/icons/IconMoon.mjs";
import IconNetwork from "@tabler/icons-react/dist/esm/icons/IconNetwork.mjs";
import IconPalette from "@tabler/icons-react/dist/esm/icons/IconPalette.mjs";
import IconPaperclip from "@tabler/icons-react/dist/esm/icons/IconPaperclip.mjs";
import IconPdf from "@tabler/icons-react/dist/esm/icons/IconPdf.mjs";
import IconPencil from "@tabler/icons-react/dist/esm/icons/IconPencil.mjs";
import IconPlayerPause from "@tabler/icons-react/dist/esm/icons/IconPlayerPause.mjs";
import IconPlayerPauseFilled from "@tabler/icons-react/dist/esm/icons/IconPlayerPauseFilled.mjs";
import IconPlayerPlayFilled from "@tabler/icons-react/dist/esm/icons/IconPlayerPlayFilled.mjs";
import IconPlus from "@tabler/icons-react/dist/esm/icons/IconPlus.mjs";
import IconQuestionMark from "@tabler/icons-react/dist/esm/icons/IconQuestionMark.mjs";
import IconRefresh from "@tabler/icons-react/dist/esm/icons/IconRefresh.mjs";
import IconReplace from "@tabler/icons-react/dist/esm/icons/IconReplace.mjs";
import IconRobotFace from "@tabler/icons-react/dist/esm/icons/IconRobotFace.mjs";
import IconRotate from "@tabler/icons-react/dist/esm/icons/IconRotate.mjs";
import IconRotateDot from "@tabler/icons-react/dist/esm/icons/IconRotateDot.mjs";
import IconRss from "@tabler/icons-react/dist/esm/icons/IconRss.mjs";
import IconSearch from "@tabler/icons-react/dist/esm/icons/IconSearch.mjs";
import IconSettings from "@tabler/icons-react/dist/esm/icons/IconSettings.mjs";
import IconShieldLock from "@tabler/icons-react/dist/esm/icons/IconShieldLock.mjs";
import IconSlash from "@tabler/icons-react/dist/esm/icons/IconSlash.mjs";
import IconSparkles from "@tabler/icons-react/dist/esm/icons/IconSparkles.mjs";
import IconSpeakerphone from "@tabler/icons-react/dist/esm/icons/IconSpeakerphone.mjs";
import IconSquare from "@tabler/icons-react/dist/esm/icons/IconSquare.mjs";
import IconSquareCheckFilled from "@tabler/icons-react/dist/esm/icons/IconSquareCheckFilled.mjs";
import IconSquareChevronsLeftFilled from "@tabler/icons-react/dist/esm/icons/IconSquareChevronsLeftFilled.mjs";
import IconStack2 from "@tabler/icons-react/dist/esm/icons/IconStack2.mjs";
import IconStar from "@tabler/icons-react/dist/esm/icons/IconStar.mjs";
import IconStrikethrough from "@tabler/icons-react/dist/esm/icons/IconStrikethrough.mjs";
import IconSun from "@tabler/icons-react/dist/esm/icons/IconSun.mjs";
import IconSwitch from "@tabler/icons-react/dist/esm/icons/IconSwitch.mjs";
import IconTable from "@tabler/icons-react/dist/esm/icons/IconTable.mjs";
import IconTarget from "@tabler/icons-react/dist/esm/icons/IconTarget.mjs";
import IconTargetArrow from "@tabler/icons-react/dist/esm/icons/IconTargetArrow.mjs";
import IconTent from "@tabler/icons-react/dist/esm/icons/IconTent.mjs";
import IconTimeline from "@tabler/icons-react/dist/esm/icons/IconTimeline.mjs";
import IconTrash from "@tabler/icons-react/dist/esm/icons/IconTrash.mjs";
import IconTrophy from "@tabler/icons-react/dist/esm/icons/IconTrophy.mjs";
import IconUpload from "@tabler/icons-react/dist/esm/icons/IconUpload.mjs";
import IconUser from "@tabler/icons-react/dist/esm/icons/IconUser.mjs";
import IconUserCheck from "@tabler/icons-react/dist/esm/icons/IconUserCheck.mjs";
import IconUserCircle from "@tabler/icons-react/dist/esm/icons/IconUserCircle.mjs";
import IconUserPlus from "@tabler/icons-react/dist/esm/icons/IconUserPlus.mjs";
import IconUserStar from "@tabler/icons-react/dist/esm/icons/IconUserStar.mjs";
import IconUserX from "@tabler/icons-react/dist/esm/icons/IconUserX.mjs";
import IconUsers from "@tabler/icons-react/dist/esm/icons/IconUsers.mjs";
import IconVideo from "@tabler/icons-react/dist/esm/icons/IconVideo.mjs";
import IconWorld from "@tabler/icons-react/dist/esm/icons/IconWorld.mjs";
import IconX from "@tabler/icons-react/dist/esm/icons/IconX.mjs";
import IconLayoutKanban from "@tabler/icons-react/dist/esm/icons/IconLayoutKanban.mjs";
import IconAdjustmentsHorizontal from "@tabler/icons-react/dist/esm/icons/IconAdjustmentsHorizontal.mjs";

import type { IconProps as TablerIconProps } from "@tabler/icons-react";

export {
  IconActivity,
  IconAlertTriangle,
  IconAlertTriangleFilled,
  IconAlignJustified,
  IconArchive,
  IconArrowBackUp,
  IconArrowForwardUp,
  IconArrowLeft,
  IconArrowRight,
  IconArrowsMaximize,
  IconArrowsMinimize,
  IconBell,
  IconBellOff,
  IconBinaryTree2,
  IconBlockquote,
  IconBold,
  IconBrandDiscordFilled,
  IconBrandGithub,
  IconBrandSlack,
  IconBriefcase,
  IconBuilding,
  IconBuildingCommunity,
  IconBuildingEstate,
  IconBulb,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarMinus,
  IconCalendarPlus,
  IconChartColumn,
  IconCheck,
  IconChecklist,
  IconChecks,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleArrowRight,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleDashed,
  IconCircleDot,
  IconCircleFilled,
  IconCircleKey,
  IconCircleX,
  IconCircleXFilled,
  IconClipboardCheck,
  IconClipboardText,
  IconClock,
  IconClockPlay,
  IconCoffee,
  IconCopy,
  IconDeviceLaptop,
  IconDoorExit,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExchange,
  IconExclamationCircleFilled,
  IconExternalLink,
  IconEye,
  IconFile,
  IconFileExport,
  IconFileFilled,
  IconFileText,
  IconFileZip,
  IconFilter,
  IconFlag,
  IconFlag3Filled,
  IconFlagFilled,
  IconFlagX,
  IconFlare,
  IconFolderFilled,
  IconGripVertical,
  IconGrowth,
  IconH1,
  IconH2,
  IconH3,
  IconH4,
  IconHash,
  IconHeart,
  IconHexagons,
  IconHistory,
  IconHome,
  IconHome2,
  IconId,
  IconInfoCircle,
  IconInfoCircleFilled,
  IconInfinity,
  IconItalic,
  IconKeyboard,
  IconLayoutGrid,
  IconLetterCase,
  IconLifebuoy,
  IconLink,
  IconList,
  IconListCheck,
  IconListNumbers,
  IconLock,
  IconLockFilled,
  IconLockPassword,
  IconLogs,
  IconMail,
  IconMailFast,
  IconMap2,
  IconMenu2,
  IconMessage,
  IconMessagePlus,
  IconMessageCircle,
  IconMessages,
  IconMinus,
  IconMoodPlus,
  IconMoodSad,
  IconMoon,
  IconNetwork,
  IconPalette,
  IconPaperclip,
  IconPdf,
  IconPencil,
  IconPlayerPause,
  IconPlayerPauseFilled,
  IconPlayerPlayFilled,
  IconPlus,
  IconQuestionMark,
  IconRefresh,
  IconReplace,
  IconRobotFace,
  IconRotate,
  IconRotateDot,
  IconRss,
  IconSearch,
  IconSettings,
  IconShieldLock,
  IconSlash,
  IconSparkles,
  IconSpeakerphone,
  IconSquare,
  IconSquareCheckFilled,
  IconSquareChevronsLeftFilled,
  IconStack2,
  IconStar,
  IconStrikethrough,
  IconSun,
  IconSwitch,
  IconTable,
  IconTarget,
  IconTargetArrow,
  IconTent,
  IconTimeline,
  IconTrash,
  IconTrophy,
  IconUpload,
  IconUser,
  IconUserCheck,
  IconUserCircle,
  IconUserPlus,
  IconUsers,
  IconUserStar,
  IconUserX,
  IconVideo,
  IconWorld,
  IconX,
  IconLayoutKanban,
  IconAdjustmentsHorizontal,
};

export interface IconProps {
  size?: number;
  className?: string;
}

export type { TablerIconProps };

export function IconTask({ size = 16, className = "" }: IconProps) {
  const outer = classNames(
    "flex-shrink-0 rounded-full flex items-center justify-center",
    "text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30",
    className,
  );

  const innerSize = size - 8;

  return (
    <div className={outer} style={{ width: size, height: size }}>
      <IconCheck size={innerSize} stroke={3} />
    </div>
  );
}

export function IconGoal({ size = 16, className = "" }: IconProps) {
  const outer = classNames(
    "flex-shrink-0 rounded-full flex items-center justify-center",
    "text-red-500 dark:text-red-400 bg-red-50 dark:bg-red-900/30",
    className,
  );

  const innerSize = size - 8;

  return (
    <div className={outer} style={{ width: size, height: size }}>
      <IconTarget size={innerSize} />
    </div>
  );
}

export function IconGoalPlain({ size = 16, className = "" }: IconProps) {
  const outer = classNames(
    "flex-shrink-0 rounded-full flex items-center justify-center",
    "text-red-500 dark:text-red-400 dark:bg-red-900/30",
    className,
  );
  return <IconTarget size={size} className={outer} />;
}

export function IconProject({ size = 16, className = "" }: IconProps) {
  const outer = classNames(
    "flex-shrink-0 w-5 rounded-full flex items-center justify-center",
    "text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30",
    className,
  );

  const innerSize = size - 8;

  return (
    <div className={outer} style={{ width: size, height: size }}>
      <IconChecklist size={innerSize} />
    </div>
  );
}

export function IconProjectPlain({ size = 16, className = "" }: IconProps) {
  const outer = classNames(
    "flex-shrink-0 w-5 rounded-full flex items-center justify-center",
    "text-blue-500 dark:text-blue-400 dark:bg-blue-900/30",
    className,
  );

  return <IconChecklist size={size} className={outer} />;
}

export function IconMilestone({ size = 16, className = "" }: IconProps) {
  const outer = classNames(
    "flex-shrink-0 rounded-full flex items-center justify-center",
    "text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30",
    className,
  );

  const innerSize = size - 8;

  return (
    <div className={outer} style={{ width: size, height: size }}>
      <IconFlag size={innerSize} />
    </div>
  );
}

export function IconPaintBucket({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className = "",
  ...props
}: TablerIconProps) {
  const { stroke, ...otherProps } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      stroke={color}
      {...otherProps}
    >
      <path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z" />
      <path d="m5 2 5 5" />
      <path d="M2 13h15" />
      <path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z" />
    </svg>
  );
}

export function IconCode({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className = "",
  ...props
}: TablerIconProps) {
  const { stroke, ...otherProps } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      stroke={color}
      {...otherProps}
    >
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </svg>
  );
}

export function IconLink2({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className = "",
  ...props
}: TablerIconProps) {
  const { stroke, ...otherProps } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      stroke={color}
      {...otherProps}
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  );
}

// Custom CircleCheck icon with prominent checkmark
//
// Why custom instead of Tabler's IconCircleCheckFilled:
// - Tabler icons have built-in whitespace within their 24x24 viewBox and use stroke-based design
// - This makes the checkmark inside IconCircleCheckFilled very small and hard to see
// - Custom SVGs that use fill-based design and full viewBox utilization appear more prominent
// - This implementation uses a 24x24 viewBox (matching Tabler) but with optimized sizing:
//   * Circle spans from 2-22 (radius 10) leaving minimal padding
//   * Checkmark is carefully positioned and sized for visibility
//   * Uses currentColor to inherit design system colors (text-success)
export function IconCircleCheckCustom({ size = 14, className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={`${className} flex-shrink-0`}
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17.3 9.8C17.69 9.41 17.69 8.78 17.3 8.39C16.91 8 16.28 8 15.89 8.39L10.5 13.78L8.11 11.39C7.72 11 7.09 11 6.7 11.39C6.31 11.78 6.31 12.41 6.7 12.8L9.8 15.9C10.19 16.29 10.82 16.29 11.21 15.9L17.3 9.8Z"
        fill="currentColor"
      />
    </svg>
  );
}

// Custom CircleX icon for canceled status
// More prominent than Tabler's IconX in a filled circle, designed to match IconCircleCheckCustom
export function IconCircleXCustom({ size = 14, className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={`${className} flex-shrink-0`}
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.24 9.26C16.63 8.87 16.63 8.24 16.24 7.85C15.85 7.46 15.22 7.46 14.83 7.85L12 10.68L9.17 7.85C8.78 7.46 8.15 7.46 7.76 7.85C7.37 8.24 7.37 8.87 7.76 9.26L10.59 12.09L7.76 14.92C7.37 15.31 7.37 15.94 7.76 16.33C8.15 16.72 8.78 16.72 9.17 16.33L12 13.5L14.83 16.33C15.22 16.72 15.85 16.72 16.24 16.33C16.63 15.94 16.63 15.31 16.24 14.92L13.41 12.09L16.24 9.26Z"
        fill="currentColor"
      />
    </svg>
  );
}
